import { HIGHLIGHTER_COLORS, PEN_COLORS, PEN_WIDTHS, type ToolPrefs } from './tools';

export function Toolbar({ prefs, onChange }: { prefs: ToolPrefs; onChange: (p: ToolPrefs) => void }) {
  const isPen = prefs.active === 'pen';
  return (
    <div class="toolbar" role="toolbar" aria-label="Tools">
      <button class={`tool ${isPen ? 'on' : ''}`} onClick={() => onChange({ ...prefs, active: 'pen' })}>Pen</button>
      <button class={`tool ${!isPen ? 'on' : ''}`} onClick={() => onChange({ ...prefs, active: 'highlighter' })}>Highlighter</button>
      <span class="sep" />
      {isPen ? (
        <>
          {PEN_COLORS.map((c) => (
            <button
              key={c.value} class={`swatch ${prefs.pen.color === c.value ? 'on' : ''}`} title={c.name} aria-label={c.name}
              style={{ '--c': c.value }} onClick={() => onChange({ ...prefs, pen: { ...prefs.pen, color: c.value } })}
            />
          ))}
          <span class="sep" />
          {PEN_WIDTHS.map((w) => (
            <button
              key={w.value} class={`width ${prefs.pen.baseWidth === w.value ? 'on' : ''}`} title={w.name} aria-label={w.name}
              onClick={() => onChange({ ...prefs, pen: { ...prefs.pen, baseWidth: w.value } })}
            >
              <span style={{ height: `${w.value * 1.4}px` }} />
            </button>
          ))}
        </>
      ) : (
        HIGHLIGHTER_COLORS.map((c) => (
          <button
            key={c.value} class={`swatch hl ${prefs.highlighter.color === c.value ? 'on' : ''}`} title={c.name} aria-label={c.name}
            style={{ '--c': c.value }} onClick={() => onChange({ ...prefs, highlighter: { color: c.value } })}
          />
        ))
      )}
    </div>
  );
}
